export default "__VITE_ASSET__CYQ6cI$A__"